<template>
  <div class="wrapper">
    <van-cell-group>
    <div class="question">
      1.您对<span>疑似食物过敏</span>的患儿的<span>首次【诊断过程】中</span>，您通常会采用哪些步骤进行诊断？（多选）
    </div>
    <van-checkbox-group v-model="result" @change="changeEvent">
      <van-checkbox v-for="(item, index) in answerObj.answers" :key="index" :name="item.sort">{{item.seq}}</van-checkbox>
    </van-checkbox-group>
    <div v-if="result.includes(6)" style="margin-top:10px">
      <el-input type="textarea" v-model="answerOther" size="mini" maxlength="50" :rows="3" placeholder="请说明其他诊断方法" @change="inputEvent"/>
    </div>
    </van-cell-group>
  </div>
</template>
<script>
import API from "@/api/common";
export default {
  name: 'typingFirst',
  data() {
    return {
      result: [],
      confirm: '',
      coverUrl: '',
      defaultCoverUrl: require('../../../../assets/images/typing.jpg'),
      answerObj: {
        sort: '1.a',
        title: '请假设，如果有100个疑似食物过敏的患儿，您会为其中百分之多少的患者使用以下不同的方法进行诊断？',
        answers: [
          { sort: 1, seq: 'A、询问病史、家族史、喂养史等情况', checked: false },
          { sort: 2, seq: 'B、观察临床症状和体格检查', checked: false },
          { sort: 3, seq: 'C、实验室检查：包括皮肤点刺试验（SPT）、血清特异性IgE检测（sIgE）、特异性斑贴试验（APT）、嗜酸性粒细胞等', checked: false},
          { sort: 4, seq: 'D、食物回避（包括母亲饮食回避）', checked: false},
          { sort: 5, seq: 'E、口服激发试验', checked: false },
          { sort: 6, seq: 'F、其他，请说明', checked: false, other: '' },
        ]
      },
      answerOther: ''
    };
  },
  created() {
    
  },
  methods: {
    changeEvent(e) {
      this.answerObj.answers.forEach(item => {
        if (this.result.includes(item.sort)) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
      console.log(this.answerObj.answers)
      this.$emit('getResultA', this.result)
    },
    inputEvent(e) {
      this.answerObj.answers[5].other = e
      console.log(this.answerObj.answers)
    }
  }
};
</script>

<style lang="less">
  .question {
    span {
        color: purple;
        font-weight: bold;
    }
  }
  .options {
      font-size: 14px;
      margin: 0 10px;
      padding-top: 10px;
      // border-bottom: 1px solid #eee;
      // &:last-child {
      //   border-bottom: 1px solid #fff;
      // }
      .van-checkbox {
     
      }
  }
  .operation {
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      .total {
          line-height: 28px;
      }
      .tips {
        color: red;
        text-align: right;
        line-height: 28px;
      }
  }

</style>
